<template>
    <div class="authors">

      <loader></loader>

      <div class="page-title-container">
          <h1>Auteurs</h1>
      </div>

      <scroll-progress-bar></scroll-progress-bar>

        <div class="row row--all scroll">
          <div class="col-md-11 col-md-offset-1">
            <div class="vertical-list-container">
              <div class="vertical-list-wrapper">
                <div class="inner-links">
                  <router-link :to="{ name: 'home' }">
                    <span class="dash"></span>
                    Retour à l’accueil
                  </router-link>
                </div>
                <div class="page-subtitle-container">
                  <span class="dash"></span>
                  <h2>Les auteurs de<br> l'Anthologie Palatine</h2>
                </div>

                <h3 v-for="author in dataAuthors">
                  <span class="bg"></span>
                  <router-link :to="{ name: 'authorSingle', params: { id: author.id_author }}">
                    {{ author.versions[0].name }} <sup>{{ author.id_author | romanize }}</sup>
                  </router-link>
                </h3>
                <!--
                Do not show author epigrams in this view
                Issue #9
                https://framagit.org/anthologie-palatine/anthologie-palatine-client/issues/9
                <ul>
                  <li v-for="epigram in author.entities">
                    <router-link :to="{ name: 'epigram', params: { id: epigram.id_entity }}">{{ epigram.title }}</router-link>
                  </li>
                </ul>
                -->
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import BackBtn from './partials/BackBtn'
import Loader from './partials/Loader'
import ScrollProgressBar from './partials/ProgressBar'

//import $ from 'jquery'

export default {
  components: {
    BackBtn,
    Loader,
    ScrollProgressBar
  },
  name: 'Authors',
  data () {
    return {
      dataAuthors: {}
    }
  },
  created: function () {
    this.$nextTick(function () {
      // ensure elements are in-document
      // immediately show loader
      Loader.methods.show()
    })
    this.getAuthorsData()
  },
  methods: {
    getAuthorsData: function () {
      var self = this
//      this.$http.get(global.apiAuth).then(function (response) {
//      self.$set('token', response.data.access_token)
      //
      self.$http.get(global.api + 'authors'/* + filterFr + 'access_token=' + self.token*/, {progress () {
      }}).then(function (response) {
        var authors = JSON.parse(response.bodyText)

        // order authors alphabetically
        function compare (a, b) {
          if (a.versions[0].name < b.versions[0].name) {
            return -1
          }
          if (a.versions[0].name > b.versions[0].name) {
            return 1
          }
          return 0
        }

        self.$set(this, 'dataAuthors', authors.sort(compare))
      }, function (response) {
        console.log('Error retrieving authors', response)
      }).finally(function () {
        Loader.methods.hide()
      })
//      }, function (response) {
//        console.log('global error: ' + response.status)
//      })
    }
  }
}
</script>

<style lang="sass" scoped>
$hover: .5s all linear
$raleway: 'Raleway', Helvetica, Arial, sans-serif

.authors
  width: 100%
  height: 100%

</style>



// WEBPACK FOOTER //
// AuthorsComponent.vue?179a24e4